// servizi/versione.ts — v040: confronto delle versioni (tre cifre, es. 039), senza dipendenze (si prova da solo).
export function piuNuovaDi(server: string | null | undefined, mia: string): boolean {
  if (!server || !/^\d{3}$/.test(server) || !/^\d{3}$/.test(mia)) return false;
  return Number(server) > Number(mia);
}
